import { ICurrentLegalDocumentsResponse } from "types/LegalDocuments/LegalDocuments";

import { publicApi } from ".";

const legalDocumentsQueries = publicApi.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentLegalDocuments: builder.query<
      ICurrentLegalDocumentsResponse,
      void
    >({
      query: () => ({
        url: "legal-documents/current",
        method: "GET",
      }),
    }),
  }),
});

export const { useGetCurrentLegalDocumentsQuery } = legalDocumentsQueries;
